import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { exchangeGoogleSession, apiErr } from './api';

// Handles the Emergent Google sign-in return (#session_id=...) and swaps it for an Academy session.
export const LmsAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get('session_id');
    const back = location.pathname + location.search;
    exchangeGoogleSession(sid)
      .then((s) => { toast.success(`Signed in as ${s.email}`); navigate(back, { replace: true }); })
      .catch((e) => { toast.error(apiErr(e)); navigate(back, { replace: true }); });
  }, [location, navigate]);

  return <div data-testid="lms-auth-callback" style={{ minHeight: '60vh' }} />;
};
